export default __webpack_public_path__ + "static/media/receptionist_room.4e46d673.png";